import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import format from '../../helpers/format'
import {
  Link,
} from '../../components'
import Styles from './FundMoreInfoTable.css'


@CSSModules(Styles)
export default class FundMoreInfoTable extends Component {
  static propTypes = {
    shareClass: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    
    const capitalizeFirstLetter = (val) => {
      return String(val).charAt(0).toUpperCase() + String(val).slice(1);
    }

    const formatUrlParam = (val) => {
      return encodeURIComponent(val).replace(/%20/g, '+')
    }


// /funds?dsc=false&srt=grade_rji&grp=Allocation

// /funds?dsc=false&srt=grade_rji&fdc=China+Region

// /funds?dsc=false&srt=grade_rji&typ=TSP

// /families?q=Vanguard

    this.state = {
      tableConfig: [
        [
          'Shareclass ticker',
          this.props.shareClass.ticker
        ],
        [
          'Portfolio holdings date',
          this.props.shareClass.date.slice(0, 10)
        ],
        [
          'Shareclass name',
          this.props.shareClass.name
        ],
        [
          '% of fund assets analyzed',
          format.perc(
            this.props.shareClass.percent_rated
          )
        ],
        [
          'Shareclass type',
          <Link
            xstrong
            title='Search funds with this shareclass type'
            to={'/funds?dsc=false&srt=grade_rji&typ='+this.props.shareClass.legal_type}
          >
            {format.legalType(this.props.shareClass.legal_type)}
          </Link>
        ],
        [
          'Fund net assets',
          format.money(
            this.props.shareClass.fund_net_assets,
            false,
            'USD',
            false,
            0
          )
        ],
        [
          'Fund manager',
          <Link
            xstrong
            title='See funds from this manager'
            to={'/families?q='+this.props.shareClass.fund_family_name}
          >
            {this.props.shareClass.fund_family_name}
          </Link>
        ],
        // [
        //   'Fund category',
        //   <Link
        //     xstrong
        //     title='Search funds in this category'
        //     to={'/funds?dsc=false&srt=grade_rji&fdc='+formatUrlParam(this.props.shareClass.morningstar_category_name)}
        //   >
        //     {this.props.shareClass.morningstar_category_name}
        //   </Link>
        // ],
        [
          'Fund category group',
          <Link
            xstrong
            title='Search funds in this category group'
            to={'/funds?dsc=false&srt=grade_rji&grp='+formatUrlParam(this.props.shareClass.category_group)}
          >
            {this.props.shareClass.category_group}
          </Link>
        ],
        [
          'Sustainability mandate',
          format.boolean(this.props.shareClass.ussif)
        ],
        // [
        //   'Non-diversification risk',
        //   capitalizeFirstLetter(this.props.shareClass.non_diversified_fund)
        // ],
      ],
    }
  }
  //
  render() {
    return <div styleName='fund-more-info-table'>
      {
        this.state.tableConfig.map((e, i) => {
          return <div styleName='fund-more-info-table__item'>
            <div styleName='fund-more-info-table__cell'>
              {e[0]}
            </div>
            <div styleName='fund-more-info-table__cell'>
              {e[1]}
            </div>
          </div>
        })
      }
    </div>
  }
}
